package com.daytimegaming.ourdailyfinances.presentation.legal

import androidx.compose.runtime.Composable
import androidx.compose.runtime.produceState
import org.jetbrains.compose.resources.ExperimentalResourceApi
import ourdailyfinances.shared.generated.resources.Res

object LegalDocuments {
    @OptIn(ExperimentalResourceApi::class)
    suspend fun loadPrivacyPolicyText(): String {
        return Res.readBytes("files/privacy_policy.md").decodeToString()
    }

    @OptIn(ExperimentalResourceApi::class)
    suspend fun loadTermsOfServiceText(): String {
        return Res.readBytes("files/terms_of_service.md").decodeToString()
    }
}

@Composable
fun rememberPrivacyPolicyText(): String? {
    val textState = produceState<String?>(initialValue = null) {
        value = try {
            LegalDocuments.loadPrivacyPolicyText()
        } catch (e: Exception) {
            null
        }
    }
    return textState.value
}

@Composable
fun rememberTermsOfServiceText(): String? {
    val textState = produceState<String?>(initialValue = null) {
        value = try {
            LegalDocuments.loadTermsOfServiceText()
        } catch (e: Exception) {
            null
        }
    }
    return textState.value
}
